import React from 'react'
import LinkBox from './LinkBox';

export type NOMLinkBoxRowProps = {};

const NOMLinkBoxRow: React.FC<NOMLinkBoxRowProps> = () => {
  return (
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-center max-w-5xl m-auto pt-20 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/NOM/NOM-001-SCFI-2018"} label={"NOM-001-SCFI-2018"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/NOM/NOM-016-SCFI-1993"} label={"NOM-016-SCFI-1993"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/NOM/NOM-019-SCFI-1998"} label={"NOM-019-SCFI-1998"} />
      </div>
      <div className='w-full md:w-1/3'>
        <LinkBox href={"/NOM/NOM-003-SCFI-2014"} label={"NOM-003-SCFI-2014"} />
      </div>
    </div>
  );
}

export default NOMLinkBoxRow;